const stats = [
  {
    number: "500+",
    title: "Courses",
  },
  {
    number: "50K+",
    title: "Learners",
  },
  {
    number: "120+",
    title: "Companies",
  },
  {
    number: "98%",
    title: "Completion Rate",
  },
];

export default function Stats() {
  return (
    <section className="bg-slate-900 py-20">

      <div className="container mx-auto">

        <div className="grid md:grid-cols-4 gap-10">

          {stats.map((item) => (

            <div
              key={item.title}
              className="text-center"
            >

              <h2 className="text-5xl font-black text-cyan-400">

                {item.number}

              </h2>

              <p className="text-slate-400 mt-3">

                {item.title}

              </p>

            </div>

          ))}

        </div>

      </div>

    </section>
  );
}